<template>
    <div v-if="langCodes?.length" :class="{'order-info-base-info': isShowLabel}">
        <span v-if="isShowLabel" class="order-info-base-info__icon">
            <v-icon start size="x-small">mdi-web</v-icon>
            <span class="text-body-2"> {{ $t('language') }}</span>
        </span>
        <div :class="isShowLabel ? 'order-info-base-info__text' : 'd-flex gc-1'">
            <div v-for="(lang, i) in langCodes" :key="lang" class="d-flex">
                <language-label :language="lang" translate />
                <div v-if="!isShowLabel && langCodes.length > 1 && i !== langCodes.length - 1">&nbsp; | &nbsp;</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import LanguageLabel from '~src/components/snippets/LanguageLabel.vue'

    @Component({
        components: {LanguageLabel},
    })
    export class TransferDriverLanguages extends Vue {
        @Prop({required: true}) langCodes
        @Prop({default: false, type: Boolean}) isShowLabel
    }

    export default TransferDriverLanguages
</script>
